import Layout from "@/components/layout";
import AuthLayout from "@/components/auth/layout";
import {
    Brand,
    Brands,
    EmailActions,
    Organization,
    Organizations,
    Product,
    Products,
    Profile,
    Settings,
    Support,
} from "@/pages";
import { Login, Reset, Signup } from "@/pages/auth";
import storage from "@/utils/storage";
import React from "react";
import { Navigate, Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";

const router = createBrowserRouter(
    createRoutesFromElements(
        <React.Fragment>
            <Route
                path="*"
                Component={() => {
                    const oid = storage.getItem("oid");
                    const route = oid ? `/organization/${oid}/brands` : "/organization";
                    const lastLogin = storage.getItem("lastLogin");

                    if (lastLogin) return <Navigate to={route} />;
                    return <Login />;
                }}
            />
            <Route element={<AuthLayout />}>
                <Route path="/sign-in" element={<Login />} />
                <Route path="/sign-up" element={<Signup />} />
                <Route path="/reset-password" element={<Reset />} />
            </Route>
            <Route path="/email-actions" element={<EmailActions />} />
            <Route
                path="/organization"
                Component={() => {
                    const oid = storage.getItem("oid");
                    const hasMultipleOrgs = storage.getItem("hasMultipleOrgs");

                    if (hasMultipleOrgs && !oid) return <Navigate to="/organizations" />;
                    if (oid) return <Navigate to={`/organization/${oid}/brands`} />;
                    return <Organization />;
                }}
            />
            <Route element={<Layout />}>
                <Route
                    path="/organizations"
                    Component={() => {
                        const oid = storage.getItem("oid");
                        const hasMultipleOrgs = storage.getItem("hasMultipleOrgs");
                        if (!hasMultipleOrgs && oid) {
                            return <Navigate to={`/organization/${oid}/brands`} />;
                        }

                        return <Organizations />;
                    }}
                />
                <Route path="/support" element={<Support />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/organization/:oid">
                    <Route path="settings" element={<Settings />} />
                    <Route path="brands" element={<Brands />} />
                    <Route path="brand">
                        <Route path="" element={<Brand />} />
                        <Route path=":bid" element={<Brand />} />
                    </Route>
                    <Route path="brands/:bid/products" element={<Products />} />
                    <Route path="brands/:bid/product/:typeName">
                        <Route path="" element={<Product />} />
                        <Route path=":pid" element={<Product />} />
                    </Route>
                </Route>
            </Route>
        </React.Fragment>,
    ),
);

export default router;
